var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-ui"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_vm._v(" "),_c('i',{class:{
    "icon far fa-square": !_vm.value && !_vm.partSelected,
    "icon far fa-check-square": _vm.value && !_vm.partSelected,
    "icon far fa-minus-square": _vm.partSelected
  }}),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }